/****************************************************
 * Module Name:  labTestProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class LabTestProxy {
  static GetAllTestingStonesInALab = (labId, status, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/${labId}/INPROGRESS/${status}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllTestingStonesInALabDetail = (labId, status, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/${labId}/INPROGRESS/${status}/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllTestingStonesInALabDetailReport = (
    labId,
    status,
    data,
    callback
  ) => {
    restAPICall(
      Constants.MANAGER_URL +
      `/stone/lab/${labId}/INPROGRESS/${status}/user/detail`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllTestSummary = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/labstatuscount`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetLabTestingSummaryStones = (id, lab, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/${lab}/detailbybatch/${id}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    ).then((response) => callback(response));
  };

  static GetAllApproveRejectStones = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/needapprovereject`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSymMaster = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/master/sym`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetPolMaster = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/master/pol`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetFloMaster = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/master/flo`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetCutMaster = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/master/cut`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetClarityMaster = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/master/clarity`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetColorMaster = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/master/color`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
  static GetAllPricingStones = (stonetype, callback) => {
    let params = {
      stonetype: stonetype,
    };
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/needpricing`,
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    ).then((response) => callback(response));
  };

  static GetAllTaggingStones = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/needtagging`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllPricingApprovalStones = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/pricingapproval`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    ).then((response) => callback(response));
  };

  static SendForPriceApproval = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/pricingapproval/sendForPriceApproval",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetStoneByStatus = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stone/labtest/stock/query",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static SendStonesToLab = (labId, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/${labId}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static SendStonesForReCheck = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/recheck`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static MarkStoneReceived = (labId, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/${labId}`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static ApproveStones = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/approve`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddPricing = (data, stonetype, callback) => {
    let params = {
      stonetype: stonetype,
    };
    restAPICall(
      Constants.MANAGER_URL + `/pricingapproval/createPricingApproval`,
      "post",
      Constants.userToken,
      params,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddTagging = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/addtagging`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static RejectStones = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/reject`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static RejectStonesToMix = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/mix`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UploadFile = (file, labName, callback) => {
    restAPICall(
      Constants.WORKER_URL + `/upload/${labName}`,
      "post",
      Constants.userToken,
      undefined,
      file,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddStonesToMix = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/lab/mix/newtest`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
